<template>
  <div>
    <b-row v-if="data.length > 0">
      <b-col
        dir="ltr"
        cols="12"
        class="d-flex mb-2"
        v-for="(item, i) in data"
        :key="i"
      >
        <div class="pl-2 nameChart text-left">
          <b>{{ item.name }}</b>
        </div>
        <div class="bg-white w-100 d-flex">
          <div
            v-for="(value, y) in item.levels"
            :style="{
              backgroundColor: `#e1e1e1`,
              width: withdDiv(y),
              height: `100%`,
            }"
            :key="y"
            class="m-1 d-flex"
          >
            <div
              :style="{
                backgroundColor: `rgb(218 95 107)`,
                width: value + `%`,
                height: `100%`,
              }"
            ></div>
          </div>
        </div>
        <div class="pr-2 socre">
          <b>{{ `%${parseInt(item.normalized_percent)}` }}</b>
        </div>
      </b-col>
      <b-col dir="ltr" cols="12" class="d-flex">
        <div class="pl-2 nameChart"><b class="visibility-hidden">name</b></div>
        <div
          class="text-center fs_12"
          v-for="(item, i) in labels"
          :key="i"
          :style="{ width: item.value + `%` }"
        >
          <b>{{ item.title }}</b>
        </div>
        <div class="pl-r socre"><b class="visibility-hidden">100</b></div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      labels: [
        {
          value: 40,
          title: "بدون ریسک",
        },
        {
          value: 30,
          title: "کم ریسک",
        },
        {
          value: 20,
          title: "ریسک متوسط",
        },
        {
          value: 10,
          title: "ریسک بالا",
        },
      ],
    };
  },
  methods: {
    withdDiv(i) {
      let width = null;
      switch (i) {
        case 0:
          width = `40%`;
          break;
        case 1:
          width = `30%`;
          break;
        case 2:
          width = `20%`;
          break;
        case 3:
          width = `10%`;
          break;
      }
      return width;
    },
  },
};
</script>


<style lang="scss" scoped>
.nameChart {
  width: 200px;
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
}

.socre {
  width: 60px;
  overflow: hidden;
  white-space: nowrap;
}
</style>